import Component from'./component';import EnhancePopUpAlert from'./enhancers/EnhancePopUpAlert';export default EnhancePopUpAlert(Component);